import { render } from "./ReviewsComp.vue?vue&type=template&id=6b23ddec&scoped=true"
import script from "./ReviewsComp.vue?vue&type=script&scoped=true&lang=js"
export * from "./ReviewsComp.vue?vue&type=script&scoped=true&lang=js"

import "./ReviewsComp.vue?vue&type=style&index=0&id=6b23ddec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b23ddec"]])

export default __exports__